import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { GL_ASSIGNMENT_API } from "./apiRoutes";
interface UseGetGroupGlListByGroupGlYearProps {
  communityId: string;
  year: string;
  groupGlMasterId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getGroupGlListByGroupGlYear = async (groupGlMasterId: string, year: string, communityId: string) =>
  await axiosAuth.get(`${GL_ASSIGNMENT_API(communityId)}/group-gl/${groupGlMasterId}/year/${year}`);

const useGetGroupGlListByGroupGlYear = ({
  queryParams,
  year,
  communityId,
  groupGlMasterId
}: UseGetGroupGlListByGroupGlYearProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["group-gl-list", groupGlMasterId, year],
    queryFn: () => getGroupGlListByGroupGlYear(groupGlMasterId, year, communityId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    enabled: !!groupGlMasterId || queryParams?.enabled,
    ...queryParams,
  });
};

export default useGetGroupGlListByGroupGlYear;
